import React, { } from "react";
import { ToastContainer } from "react-bootstrap";
import Modals from "../../components/common/Modal";

function TestLinkModel({ open, setOpen }) {

  return (
    <>
      <Modals
        title={"Signure installation"}
        show={open === true}
        // handleClose={() => setOpen("")}
        hideCancelIcon
        size="xl"
      >
        <React.Fragment>
          <ToastContainer />
          <div className='card mb-15 mb-xl-15'>
            {/* title */}
            <div className='card-header border-0 cursor-pointer'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Dear User,
                  It seems that there is an issue in Signer service in your PC. Please perform below mentioned steps to fix the issue:
                </h3>
              </div>
            </div>

            <div id='kt_account_profile_details' className='collapse show'>
              <div style={{ marginLeft: "auto", marginRight: "auto", lineHeight: '30px' }} >
                <div className='card-body border-top p-9'>
                  <div >
                    <tr>
                      <td width="7%"><b>Step 1:</b></td>
                      <td>
                        <p><a href={`${process.env.NODE_ENV === "development"
                          ? process.env.REACT_APP_END_POINT_URL_DEV
                          : process.env.REACT_APP_END_POINT_URL_PROD}/admin/afterLogin/signerdownload`} title="Download Signer-1.0.1.exe"><input type="button" value="Download and Install" /></a> <b>Signer-Tea Board</b>
                          <i>(If you have already installed in your PC, please restart service and follow step 2).</i></p>
                        <p>After successful download, please follow below steps to install:</p>
                        <table className="border-left-none border-top-none" width="100%" >
                          <tbody><tr>
                            <td>
                              <b>1.1: </b> Install <b>Signer setup</b> with <b>Run as administrator</b> mode and complete installation.
                            </td>
                          </tr>
                            <tr>
                              <td className="line-height">
                                <b className="leave-space">1.2: </b> Now start <b>Signer-1.0.1.exe</b> from desktop short-cut or start menu or &lt;Installation directory&gt;/Signer-Teaboard\Signer-Teaboard/Signer-1.0.1.exe
                              </td>
                            </tr>
                          </tbody></table>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Step 2:</b></td>
                      <td>
                        To check signer service is working properly, <input type="button" value="Click here" id="signerTest" onClick={() => window.open(`https://localhost:29739/`, '_blank')} /> <span id="signerResponse"></span>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Step 3:</b></td>
                      <td>
                        If you are able to view the link in another tab then your signer service is running correctly and then you have to refresh page and then you can continue with DSC Signatures.
                      </td>
                    </tr>
                    <tr>
                      <br /><br />
                    </tr>
                    <tr>
                      <td colSpan={3} >
                        <span>Requirement to use public key infrastructure:</span>
                        <p>
                          • Windows 7 or above <br /> • Add site as Trusted sites <br /> • Valid Digital Certificate
                        </p>
                      </td>
                    </tr>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </React.Fragment >
      </Modals>
    </>
  );
}

export default TestLinkModel;
